import React from 'react';
import { OfficeIcon } from '@domain-group/fe-co-icon';
import { ListingInfoPill } from '../listing-info-pill/listing-info-pill';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BtrPill = () => ___EmotionJSX(ListingInfoPill, {
  icon: ___EmotionJSX(OfficeIcon, {
    size: "small"
  }),
  infoText: "Build-to-Rent properties may offer a more stable lease than other rentals, and different amenities compared to other rentals.",
  color: "accentFour",
  label: "Build-to-Rent"
});